import React from 'react';
import { Box, Typography } from '@mui/material';
import DropBoxEstimate from '../../../../../../inputs/FileUploadButton/DropBoxMpi';
import FileAttachmentSingle from '../FileAttachmentSingle';
import PartsSection from './PartsSection';

const DetailPanel = ({
 row, active_vehicle, current_dealership, onDeleteAttachment, tab,
}) => (
    <Box>
      <PartsSection mpiWorkItem={row.original} vehicleId={active_vehicle.id} tab={tab} />
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
      }}
      >
      <Box sx={{ width: '25%' }}>
        <Typography variant="subtitle2">Add Files</Typography>
        <DropBoxEstimate
          vid={active_vehicle.id}
          siteid={`${current_dealership}_${active_vehicle.id}`}
          mpi_work_item_id={row.original.id}
        />
      </Box>
      <Box sx={{ width: '75%' }}>
        <ul className="list-group">
          {active_vehicle.attachments && active_vehicle.attachments.map((attachment) => {
            if (attachment.mpi_work_item_id === row.original.id) {
              return (
                <FileAttachmentSingle
                  key={`attach_${attachment.id}`}
                  attachment={attachment}
                  vehicle_id={active_vehicle.id}
                  data_id={attachment.id}
                  delete={() => onDeleteAttachment(active_vehicle.id, attachment.id)}
                />
              );
            }
            return null;
          })}
        </ul>
      </Box>
    </Box>
    </Box>
  );

export default DetailPanel;
